<script setup lang="ts">
    import {
        useHipSpineAnnotationHelpViewModel,
    } from '@/views/3d-planner/hipSpine/annotationHelp/useHipSpineAnnotationHelpViewModel';

    const vm = useHipSpineAnnotationHelpViewModel();
</script>

<template>
    <v-card v-if="vm.helpContent" class="help-panel" elevation="8" data-testid="hip-spine-help-panel">
        <div class="help-panel-header">
            <span class="help-panel-title">{{ vm.helpContent.title }}</span>
            <div class="help-panel-close" data-testid="hip-spine-help-close" @click="vm.closeHelp">
                <v-icon icon="mdi-close" size="20" />
            </div>
        </div>

        <div class="help-panel-image-wrap">
            <img v-if="vm.helpImageSrc" :src="vm.helpImageSrc" alt="" class="help-panel-image" />
            <img
                v-if="vm.helpOverlaySrc"
                :src="vm.helpOverlaySrc"
                alt=""
                class="help-panel-overlay"
            />
        </div>

        <p class="help-panel-description">{{ vm.helpContent.description }}</p>

        <ul class="help-panel-bullets">
            <li v-for="(bullet, index) in vm.helpContent.bullets" :key="index">{{ bullet }}</li>
        </ul>
    </v-card>
</template>

<style scoped lang="scss">
    .help-panel {
        padding: 20px;
        border-radius: 16px;
        background-color: rgb(var(--v-theme-surface));
        width: 494px;
        max-height: calc(100vh - 168px);
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: rgba(var(--v-theme-secondary-text)) transparent;

        &-header {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 12px;
        }

        &-title {
            font-size: 14px;
            font-weight: 700;
            line-height: 22px;
            text-align: center;
            margin-right: 20px;
            color: rgba(var(--v-theme-on-surface));
            flex-grow: 1;
        }

        &-close {
            position: absolute;
            top: 12px;
            right: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            cursor: pointer;
            flex-shrink: 0;

            &:hover {
                background-color: rgba(var(--v-theme-surface-light));
            }
        }

        &-image-wrap {
            position: relative;
            width: 100%;
            aspect-ratio: 377 / 481;
            background-color: black;
            border-radius: 14px;
            overflow: hidden;
        }

        &-image {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        &-overlay {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            pointer-events: none;
        }

        &-description {
            margin-top: 14px;
            padding: 12px 16px;
            border-radius: 12px;
            background-color: rgba(var(--v-theme-surface-light));
            font-size: 14px;
            line-height: 22px;
            color: rgba(var(--v-theme-on-surface));
        }

        &-bullets {
            margin-top: 12px;
            padding-left: 20px;
            font-size: 14px;
            line-height: 22px;
            color: rgba(var(--v-theme-secondary-text));

            li {
                margin-bottom: 8px;
            }
        }
    }
</style>
